import React from 'react'

function LoadingAnimationFullScreen() {
    return (
        <div className="LoadingAnimationFullScreen min-h-screen dark:bg-neutral-800 grid place-content-center">
            <div className="loader flex-grow flex justify-center items-center">
                <svg xmlns="http://www.w3.org/2000/svg" width="185px" height="185px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                    <circle cx="50" cy="50" r="0" fill="none" stroke="#b927d4" strokeWidth="1">
                        <animate attributeName="r" repeatCount="indefinite" dur="1.2658227848101264s" values="0;51" keyTimes="0;1" keySplines="0 0.2 0.8 1" calcMode="spline" begin="0s"></animate>
                        <animate attributeName="opacity" repeatCount="indefinite" dur="1.2658227848101264s" values="1;0" keyTimes="0;1" keySplines="0.2 0 0.8 1" calcMode="spline" begin="0s"></animate>
                    </circle><circle cx="50" cy="50" r="0" fill="none" stroke="#32c5ff" strokeWidth="1">
                        <animate attributeName="r" repeatCount="indefinite" dur="1.2658227848101264s" values="0;51" keyTimes="0;1" keySplines="0 0.2 0.8 1" calcMode="spline" begin="-0.6329113924050632s"></animate>
                        <animate attributeName="opacity" repeatCount="indefinite" dur="1.2658227848101264s" values="1;0" keyTimes="0;1" keySplines="0.2 0 0.8 1" calcMode="spline" begin="-0.6329113924050632s"></animate>
                    </circle>
                </svg>
            </div>
        </div>
    )
}

export default LoadingAnimationFullScreen